import api from '@/api'
import dayjs from 'dayjs'
import axios from 'axios'
import Jimp from 'jimp'
import jsQR from 'jsqr'
import QrCode from 'qrcode-reader'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: null,
    height: {
      default: 250,
      type: Number
    },
    outputtype: {
      default: 'url',
      type: String
    },
    multiple: {
      default: false
    },
    scaleWidth: {
      default: undefined
    },
    showOnlyButton: {
      default: false
    },
    backGroundAuto: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data: function() {
    return {
      checkSlip: false,
      filelength: 0,
      multiplefile: [],
      base64img: '',
      currentImage: this.value,
      loading: false,
      objId: null,
      uploadtimestamp: dayjs().format('x'),
      tempWidth: '',
      tempHeight: ''
    }
  },
  components: {},
  computed: {
    showImage() {
      return /(\.pdf$)/.test(this.currentImage) ? imgLink : this.currentImage
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  created: function() {
    if (this.value && /(\.pdf$)/.test(this.value)) {
      this.currentImage = imgLink
    }
    this.objId = Math.random()
  },
  methods: {
    READ_TRANSFER_SLIP(path) {
      const vm = this
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common = {}
        axios({
          method: 'get',
          url: path,
          responseType: 'arraybuffer'
        })
          .then(({ data: imageBuffer }) => {
            Jimp.read(imageBuffer, (error, image) => {
              if (error) {
                console.log(
                  `[debug] slip_verification READ_TRANSFER_SLIP Jimp error`,
                  JSON.stringify(error)
                )
                vm.$emit('verifyDataClick', { eventClick: 'select' })
                resolve(false)
              } else {
                const code = jsQR(
                  Uint8ClampedArray.from(image.bitmap.data),
                  image.bitmap.width,
                  image.bitmap.height
                )
                if (code && code.data) {
                  resolve(code.data)
                } else {
                  console.log(
                    `[debug] slip_verification READ_TRANSFER_SLIP code error`,
                    JSON.stringify(code)
                  )
                  const qr = new QrCode()
                  qr.callback = (error, data) => {
                    if (error) {
                      console.log(
                        `[debug] slip_verification READ_TRANSFER_SLIP code 2 error ${path}`,
                        JSON.stringify(error)
                      )
                      vm.$emit('verifyDataClick', { eventClick: 'select' })
                      resolve(false)
                    } else {
                      resolve(data.result)
                    }
                  }
                  qr.decode(image.bitmap)
                }
              }
            })
          })
          .catch(error => {
            console.log(
              `[debug] slip_verification READ_TRANSFER_SLIP arraybuffer error`,
              JSON.stringify(error)
            )
            vm.$emit('verifyDataClick', { eventClick: 'select' })
            resolve(false)
          })
      })
    },

    onClickUploadButton: function() {
      if (!this.disabled && !this.loading) {
        document.getElementById('photoUploadInput' + this.objId).click()
      }
    },
    fileResize: function(file) {
      let vm = this
      if (!FileReader) {
        this.$swal.fire({
          type: 'error',
          text: this.$t('Your device is unable to read the file. Please contact the shop to proceed with the payment')
        })
        return null
      }
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onloadend = function() {
          var tempImg = new Image()
          tempImg.src = reader.result
          tempImg.onload = async function() {
            var tempW = tempImg.width
            var tempH = tempImg.height
            var MAX_WIDTH = 2000
            var MAX_HEIGHT = 2000
            if (vm.outputtype == 'base64') {
              MAX_WIDTH = 500
              MAX_HEIGHT = 500
            }

            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW
                tempW = MAX_WIDTH
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH
                tempH = MAX_HEIGHT
              }
            }

            if (vm.scaleWidth) {
              let scale = vm.scaleWidth / tempW
              tempW = vm.scaleWidth
              tempH = tempH * scale
            }

            vm.tempWidth = tempW
            vm.tempHeight = tempH
            var canvas = document.createElement('canvas')
            canvas.width = tempW
            canvas.height = tempH
            var ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, tempW, tempH)
            var dataURL = null

            if (file.type == 'image/png') {
              dataURL = canvas.toDataURL('image/png')
            } else {
              dataURL = canvas.toDataURL('image/jpeg')
            }
            var data = 'image=' + dataURL
            try {
              if (vm.outputtype == 'base64') {
                vm.$emit('input', dataURL)
                vm.currentImage = dataURL
                vm.$emit('onUploaded', dataURL)
              }
              var obj = vm.dataURItoBlob(data)
              obj.name = file.name
              resolve(obj)
            } catch (error) {
              vm.$swal({
                title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                type: 'error',
                text: `dataURItoBlob: ${error}`,
                confirmButtonText: vm.$t('Confirm')
              })
              reject()
            }
          }
        }
        reader.readAsDataURL(file)
      })
    },
    dataURItoBlob: function(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: async function(event) {
      var vm = this

      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.uploadtimestamp = dayjs().format('x')
        return
      } else {
        this.loading = true
        let files = event.target.files || event.dataTransfer.files
        if (files.length > 5) {
          await this.$swal({
            title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            type: 'error',
            text: `รวมแชทสามารถส่งรูปภาพได้ไม่เกิน 5 ภาพ`,
            confirmButtonText: this.$t('Confirm')
          })
        } else {
          await this.validateFile(files)
        }

        this.loading = false
      }
      event.target.value = ''
    },
    async validateFile(files) {
      if (!files.length) {
        this.uploadtimestamp = dayjs().format('x')
        return false
      } else {
        this.filelength = files.length
      }
      if (this.multiple) {
        for (let file of files) {
          var obj = await this.fileResize(file)
          if (obj) {
            await this.createImage(obj)
          }
        }
      } else {
        try {
          var obj = null
          if (files[0].type != 'image/gif') {
            obj = await this.fileResize(files[0])
          } else {
            obj = files[0]
          }
          if (!obj) throw new Error('Something went wrong')
          if (this.outputtype != 'base64') {
            return await this.createImage(obj)
          }
        } catch (error) {
          await this.$swal({
            title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            type: 'error',
            text: `fileResize: ${error}`,
            confirmButtonText: this.$t('Confirm')
          })
        }
      }

      return false
    },
    async createImage(file) {
      try {
        return await this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    upload(file) {
      let vm = this
      // vm.$store.dispatch('loading')
      let data = {
        name: `${this.selectedBot.pageid || ''}_${dayjs().unix()}`,
        type: file.type,
        file: file
      }
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, async function(error, url) {
          if (error) {
            // vm.$store.dispatch('loading')
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          vm.$emit('input', vm.currentImage, { width: vm.tempWidth, height: vm.tempHeight })
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
              vm.multiplefile = []
            }
          } else {
            const qr_code_data = await vm.READ_TRANSFER_SLIP(vm.currentImage)
            const is_valid_result =
              qr_code_data &&
              typeof qr_code_data === 'string' &&
              qr_code_data.includes('00060000010103') &&
              !qr_code_data.includes('/')
            vm.checkSlip = is_valid_result
            if (is_valid_result) {
              const bank_code = qr_code_data.split('00060000010103')[1].substring(0, 3)
              const ref_length = parseInt(qr_code_data.split(bank_code + '02')[1].substring(0, 2))
              const ref = qr_code_data.split(bank_code + '02')[1].substring(2, ref_length + 2)
              console.log(bank_code)
              vm.$emit('update:verifyData', {
                verify_slip_bank_code: bank_code,
                verify_slip_ref: ref
              })
            }
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve(vm.currentImage)
          // vm.$store.dispatch('loading')
        })
      })
    }
  },
  watch: {
    value: function(newVal) {
      this.currentImage = newVal
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/UploadSingleFile.js